import checkPermissions from "./checkPermissions";
/**
 * @see https://sail.stripe.me/data/api/isTokenUnionMember
 */ export default function isTokenUnionMember(/** An object that is typed as a union of `PermissionToken` objects */ tokenUnion, /** An object that describes a subset of the permissions in one or more of the union members */ expected) {
    // the typecast here looks unsafe, but since we know that tokenUnion and expected are
    // compatible (by the types on the arguments), this typecast is safe
    return !!checkPermissions(tokenUnion, expected);
}

//# sourceMappingURL=isTokenUnionMember.js.map